import React from "react";


const Contact = props =>(
    <div> 
    <section id="contact" style={{marginLeft: '250px', marginTop:'40px', marginBottom:'40px',
                                    color:'#457b9d'}}>
<h3 style={{color: 'black'}}>come say hi!!</h3>
<a style={{textDecoration: 'none', color: 'inherit'}}href="https://github.com/michellenvega" target="blank">github</a>
<a style={{textDecoration: 'none', color: 'inherit'}}href="https://www.linkedin.com/in/michelle-navarrete-vega/" target="blank">linkedin</a>
<a style={{textDecoration: 'none', color: 'inherit'}}href="mailto: michellenvega@yahoo.com">email</a>
    </section>
    <hr></hr>
    </div>
)

export default Contact;